(function () {

  'use strict';

  function pxWorkflowSettings(RegexModel) {
    return {
      restrict: 'E',
      scope: {
        me: '=',
        tenant: '=',
        workflowForm: '=',
        workflowFormModel: '=',
        fileNameFormModel: '=',
        filePathFormModel_ONEDRIVE: '=filePathFormModelOnedrive',
        filePathFormModel_SHAREPOINT: '=filePathFormModelSharepoint'
      },
      templateUrl: 'app/components/settings/workflows/workflowProperties/settings/workflowSettings.template.html',
      link: function (scope, element, attrs) {

        scope.badNameString = new RegexModel().badNameString();

        scope.groups = angular.copy(scope.workflowFormModel.groups);
        scope.search = { string: '' };

        scope.handleNameChange = () => {
          scope.fileNameFormModel.handleWorkflowNameChange();
          scope.filePathFormModel_SHAREPOINT.handleWorkflowNameChange();
          scope.filePathFormModel_ONEDRIVE.handleWorkflowNameChange();
        };

        scope.openDialog = function (event, dialog) {
          event.preventDefault();
          scope.closeDialog();
          switch (dialog) {
            case 'WORKFLOW_ADD_GROUPS':
              scope.context = {
                behavior: 'ADD_GROUPS_WORKFLOW',
                name: 'SelectGroups'
              };
              scope.dialog = dialog;
              break;
          }
        };

        scope.closeDialog = function () {
          scope.context = null;
          scope.dialog = null;
        };

        scope.addGroups = function (groups) {
          groups.forEach(group => {
            if (!scope.groups.find(g => g.customProperties.id === group.customProperties.id)) {
              scope.groups.push(group);
            }
          });

          scope.groups.sort((a, b) => {
            return a.info.name.localeCompare(b.info.name);
          });

          scope.workflowFormModel.groups = scope.groups;
          scope.closeDialog();
        };

        scope.removeGroup = function (id) {
          scope.workflowFormModel.groups = scope.groups = scope.groups.filter(group => group.customProperties.id !== id);
        };

      }
    };
  }

  pxWorkflowSettings.$inject = ['RegexModel'];

  angular
    .module('printix-admin')
    .directive('pxWorkflowSettings', pxWorkflowSettings);

})();
